module.exports = require('./helpers/bundle-url').getBundleURL('8ZfPx') + "logo.c51670a8.svg";